import { Component, EventEmitter, HostListener, Input, OnChanges, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AnalyticsService } from '@services/analytics.service';
import { NAVIGATION_ROUTES } from '@shared/constants';
import { LoginComponent } from '@auth/pages/login.component';

@Component({
  selector: 'app-register-prompt-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './register-prompt-modal.component.html',
})
export class RegisterPromptModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  private bottomSheet = inject(MatBottomSheet);

  constructor(private router: Router, private analytics: AnalyticsService) {}

  ngOnChanges(changes: any) {
    if (changes.isOpen && changes.isOpen.currentValue === true) {
      this.analytics.trackEvent('modal_join-cantera', 'register_prompt_modal', 'Pop Up - Registrate');
    }
  }

  close() {
    this.closed.emit();
  }

  onRegister() {
    this.analytics.trackEvent('clicked_register', 'register_prompt', 'Boton - Empezar Registro');
    this.router.navigate([NAVIGATION_ROUTES.REGISTER]);
  }

  onLogin() {
    this.analytics.trackEvent('clicked_login', 'register_prompt', 'Boton - Ingresar 2');
    this.close();
    this.bottomSheet.open(LoginComponent, {
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'login-bottom-sheet',
    });
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.isOpen) this.close();
  }
}
